var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"home",staticClass:"home"},[(_vm.openPopup)?_c('main-notice',{attrs:{"src":_vm.popupList[0]},on:{"close":function($event){_vm.openPopup = false},"noMore":function($event){_vm.openPopup = false;
      _vm.$store.dispatch('popup/updateMain', _vm.popupList[0]._id);}}}):_vm._e(),_c('Section1'),_c('Section2'),_c('Section3'),_c('Section4'),_c('Section5'),_c('Section6'),_c('Section7'),_c('Section8'),_c('AppBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }